import { createContext, useState } from 'react';

export const RABContext = createContext();

export const RABContextProvider = ({ children }) => {
  const [indexAnalisa, setIndexAnalisa] = useState('');
  const [type, setType] = useState('');
  const [dataPrelim, setDataPrelim] = useState([]);
  const [dataAnalisaBarangJadi, setDataAnalisaBarangJadi] = useState([]);

  return (
    <RABContext.Provider
      value={{
        indexAnalisa,
        type,
        dataPrelim,
        dataAnalisaBarangJadi,
        setIndexAnalisa,
        setType,
        setDataPrelim,
        setDataAnalisaBarangJadi,
      }}
    >
      {children}
    </RABContext.Provider>
  );
};
